import React, { useContext } from 'react';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const WidgetContext = React.createContext({ id: '', setSortOrder: () => {} });

const WidgetProvider = (props) => {
    const { children } = props;

    return (
        <WidgetContext.Provider value={props}>
            {children}
        </WidgetContext.Provider>
    );
};

WidgetProvider.propTypes = { children: PropTypes.node.isRequired };

const mapStateToProps = (state, { id, widgetType, settingsNeededParams }) => {
    const widgetConfig = state.widgetPool.find(widgetSet => widgetSet.config.id === id)[widgetType];
    const settingsConfig = pick(state.settings.data, settingsNeededParams);
    const { translations } = pick(state, [ 'translations' ]);
    return { widgetConfig, settingsConfig, translations: translations.data };
};

const connectedProvider = connect(mapStateToProps, null)(WidgetProvider);

const useWidgetContext = () => {
    const context = useContext(WidgetContext);
    if (context === undefined) {
        throw new Error('useWidgetContext can only be used inside WidgetProvider');
    }
    return context;
};

export { useWidgetContext, connectedProvider as WidgetProvider };

export default WidgetContext;
